const IconDiscountTag = ({ width = 40, height = 23, fill = "#E13B30" }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 40 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 0C2.68629 0 0 2.68629 0 6V17C0 20.3137 2.68629 23 6 23H34C37.3137 23 40 20.3137 40 17V6C40 2.68629 37.3137 0 34 0H6ZM5.23871 7.66667C6.55368 7.66667 7.61966 6.59402 7.61966 5.27083C7.61966 3.94765 6.55368 2.875 5.23871 2.875C3.92375 2.875 2.85776 3.94765 2.85776 5.27083C2.85776 6.59402 3.92375 7.66667 5.23871 7.66667Z"
        fill="#E13B30"
      />
    </svg>
  );
};

export default IconDiscountTag;
